export const DEALSTATUS_LOADING = "DEALSTATUS_LOADING";
export const DEALSTATUS_RESET = "DEALSTATUS_RESET";
export const GET_DEALSTATUS = "GET_DEALSTATUS";
export const GET_DEALSTATUS_SUCCESS = "GET_DEALSTATUS_SUCCESS";
export const GET_DEALSTATUS_FAIL = "GET_DEALSTATUS_FAIL";
export const DELETE_DEALSTATUS = "DELETE_DEALSTATUS";
export const DELETE_DEALSTATUS_SUCCESS = "DELETE_DEALSTATUS_SUCCESS";
export const DELETE_DEALSTATUS_FAIL = "DELETE_DEALSTATUS_FAIL";
export const UPDATE_DEALSTATUS = "UPDATE_DEALSTATUS";
export const UPDATE_DEALSTATUS_SUCCESS = "UPDATE_DEALSTATUS_SUCCESS";
export const UPDATE_DEALSTATUS_FAIL = "UPDATE_DEALSTATUS_FAIL";
export const ADD_NEW_DEALSTATUS = "ADD_NEW_DEALSTATUS";
export const ADD_DEALSTATUS_SUCCESS = "ADD_DEALSTATUS_SUCCESS";
export const ADD_DEALSTATUS_FAIL = "ADD_DEALSTATUS_FAIL";
